'use strict';

var angular = require('angular');

module.exports = function($scope, $rootScope, $http, ExcelExportService) {
    $scope.step = 'first';
    $scope.competitionPartTwo = $rootScope.competitionPartTwo;

    $http.get('/api/game/get-chains')
        .then(function(response) {
            for (var i in response.data) {
                response.data[i].active = true;
            }

            $scope.chains = response.data;
        });

    $scope.regions = [
        {id: 'akershus', name: 'Akershus', active: true},
        {id: 'austagder', name: 'Aust-Agder', active: true},
        {id: 'buskerud', name: 'Buskerud', active: true},
        {id: 'finnmark', name: 'Finnmark', active: true},
        {id: 'hedmark', name: 'Hedmark', active: true},
        {id: 'hordaland', name: 'Hordaland', active: true},
        {id: 'moreogromsdal', name: 'Møre og Romsdal', active: true},
        {id: 'nordland', name: 'Nordland', active: true},
        {id: 'nordtrondelag', name: 'Nord-Trøndelag', active: true},
        {id: 'oppland', name: 'Oppland', active: true},
        {id: 'oslo', name: 'Oslo', active: true},
        {id: 'rogaland', name: 'Rogaland', active: true},
        {id: 'sognogfjordane', name: 'Sogn og Fjordane', active: true},
        {id: 'sortrondelag', name: 'Sør-Trøndelag', active: true},
        {id: 'telemark', name: 'Telemark', active: true},
        {id: 'troms', name: 'Troms', active: true},
        {id: 'vestagder', name: 'Vest-Agder', active: true},
        {id: 'vestfold', name: 'Vestfold', active: true},
        {id: 'ostfold', name: 'Østfold', active: true}
    ];

    $scope.setPassword = function() {
        $http({
            url: '/api/competition/check-password',
            method: 'POST',
            data: { password: $scope.password }
        }).then(function(result) {
            $scope.passwordCorrect = true;
        });
    };

    $scope.getRegion = function(id) {
        for (var i in $scope.regions) {
            if ($scope.regions[i].id == id) {
                return $scope.regions[i];
            }
        }

        return {};
    };

    $scope.getRandomWinner = function() {
        $scope.accessError = false;
        $scope.otherError = false;

        var regions = [],
            chains = [];

        for (var i in $scope.regions) {
            if ($scope.regions[i].active) {
                regions.push($scope.regions[i].id);
            }
        }

        for (var i in $scope.chains) {
            if ($scope.chains[i].active) {
                chains.push($scope.chains[i].id);
            }
        }

        $http({
            url: '/api/competition/random-winner',
            method: 'POST',
            data: {
                password: $scope.password,
                regions: regions,
                chains: chains,
                from: $scope.from,
                to: $scope.to
            }
        })
        .then(function(result) {
            $scope.winner = result.data;
        },
        function(error) {
            if (error.status == 401) {
                $scope.accessError = true;
            }
            else {
                $scope.otherError = true;
            }
        });
    };

    $scope.downloadSuggestions = function() {
        $http.get('/api/competition/suggestions?password=' + $scope.password).then(function(response) {
            ExcelExportService.download(response.data, 'suggestions.xlsx');
        });
    };
};